import { useMemo } from 'react';
import { useGetProjectConfig } from 'src/hooks';
import { ILayout } from 'src/interfaces';
import { getCurrentGlobalComponentsScreen } from 'src/utils';

export const useGlobalComponentsScreen = (
  layout?: ILayout,
  screenCount?: number,
  screenLayoutType?: string,
) => {
  const { data: { globalComponentsScreens = {} } = {} } = useGetProjectConfig();

  return useMemo(
    () =>
      getCurrentGlobalComponentsScreen(
        globalComponentsScreens,
        layout,
        screenCount,
        screenLayoutType,
      ),
    [globalComponentsScreens, layout, screenCount, screenLayoutType],
  );
};
